module.exports = __webpack_public_path__ + "img/mobilepay.00cfbb0b.svg";